// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file sticker/sticker_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { GraphicSize, StickerType } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';

/**
 * Describes the file sticker/sticker_model.proto.
 */
export const file_sticker_sticker_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChtzdGlja2VyL3N0aWNrZXJfbW9kZWwucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0In4KE1N0aWNrZXJQYWNrRW5yaWNoZWQSNgoLc3RpY2tlclBhY2sYASABKAsyIS5jb20uZ2VtLmJmZi5jb250cmFjdC5TdGlja2VyUGFjaxIvCghzdGlja2VycxgCIAMoCzIdLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlN0aWNrZXIiTgoLU3RpY2tlclBhY2sSCgoCaWQYASABKAMSEwoLZGlzcGxheU5hbWUYAiABKAkSDQoFb3JkZXIYAyABKAUSDwoHaWNvblVybBgEIAEoCSLiAQoHU3RpY2tlchIKCgJpZBgBIAEoAxITCgtkaXNwbGF5TmFtZRgCIAEoCRINCgVvcmRlchgDIAEoBRIvCgR0eXBlGAQgASgOMiEuY29tLmdlbS5iZmYuY29udHJhY3QuU3RpY2tlclR5cGUSEgoKc3RpY2tlclVybBgFIAEoCRIZCgxhbmltYXRpb25VcmwYBiABKAlIAIgBARI2CgtncmFwaGljU2l6ZRgHIAEoCzIhLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkdyYXBoaWNTaXplQg8KDV9hbmltYXRpb25VcmxCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_common_common_model]
  );

/**
 * @generated from message com.gem.bff.contract.StickerPackEnriched
 */
export type StickerPackEnriched = Message<'com.gem.bff.contract.StickerPackEnriched'> & {
  /**
   * @generated from field: com.gem.bff.contract.StickerPack stickerPack = 1;
   */
  stickerPack?: StickerPack;

  /**
   * @generated from field: repeated com.gem.bff.contract.Sticker stickers = 2;
   */
  stickers: Sticker[];
};

/**
 * Describes the message com.gem.bff.contract.StickerPackEnriched.
 * Use `create(StickerPackEnrichedSchema)` to create a new message.
 */
export const StickerPackEnrichedSchema: GenMessage<StickerPackEnriched> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_model, 0);

/**
 * @generated from message com.gem.bff.contract.StickerPack
 */
export type StickerPack = Message<'com.gem.bff.contract.StickerPack'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string displayName = 2;
   */
  displayName: string;

  /**
   * @generated from field: int32 order = 3;
   */
  order: number;

  /**
   * @generated from field: string iconUrl = 4;
   */
  iconUrl: string;
};

/**
 * Describes the message com.gem.bff.contract.StickerPack.
 * Use `create(StickerPackSchema)` to create a new message.
 */
export const StickerPackSchema: GenMessage<StickerPack> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_model, 1);

/**
 * @generated from message com.gem.bff.contract.Sticker
 */
export type Sticker = Message<'com.gem.bff.contract.Sticker'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string displayName = 2;
   */
  displayName: string;

  /**
   * @generated from field: int32 order = 3;
   */
  order: number;

  /**
   * @generated from field: com.gem.bff.contract.StickerType type = 4;
   */
  type: StickerType;

  /**
   * @generated from field: string stickerUrl = 5;
   */
  stickerUrl: string;

  /**
   * @generated from field: optional string animationUrl = 6;
   */
  animationUrl?: string;

  /**
   * @generated from field: com.gem.bff.contract.GraphicSize graphicSize = 7;
   */
  graphicSize?: GraphicSize;
};

/**
 * Describes the message com.gem.bff.contract.Sticker.
 * Use `create(StickerSchema)` to create a new message.
 */
export const StickerSchema: GenMessage<Sticker> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_model, 2);
